<div class="footer-container">

  <!-- Status Bar, Dev only stuff for now -->
  <span *ngIf="role.isDeveloper()" class="status-icons flex app-gap items-center">

    <!-- Toggle DevMode -->
    <span title="Show component outlines">Dev Mode: </span><p-toggleswitch [(ngModel)]="bitsState.devModeSignal" (ngModelChange)="settingsService.toggleDlog($event)" />

    <!-- Toggle Entra for the core API -->
    <!-- <span title="Developer only stuff">Use Entra for the core API: </span><p-toggleswitch [(ngModel)]="bitsState.useEntraSignal"  /> -->

    <!-- Toggle app component -->
    <!-- <span title="Use EZ App">Use EZ App: </span><p-toggleswitch [(ngModel)]="bitsState.useEzApp" /> -->

    <!-- Toggle footer in conent -->
    <span title="Sticky footer">Sticky footer: </span><p-toggleswitch [(ngModel)]="bitsState.stickyFooter" />

    <span *ngIf="statusBarService.entraTokenSignal()"><span class="pi pi-microsoft mr-2"></span>
      <!-- <span>Entra</span> -->
    </span>
    <span *ngIf="statusBarService.stsTokenSignal()"><span class="pi pi-key pr-2"></span>
      <!-- <span>STS</span> -->
    </span>
  </span>


  <span class="flex-spacer"></span>

  <!-- Short lived message for development -->
  <span class="dev-message" [innerHTML]="devMessageSig()"></span>

  <span class="flex-spacer"></span>

  <span *ngIf="this.appConfigService.appConfig?.pipeline?.EnvironmentName == 'LOCALHOST'">
    <span>apiHost: </span><span>{{this.appConfigService.appConfig?.env?.apiHost}}</span>
  </span>

   <!-- Version info. Clickable to see more stuff -->
  <ui-button (click)="onInfoClick($event)" [buttonText]="versionAndBuild"></ui-button>

</div>
